import { WEBUILogs } from "../logging";

/*
 * Checks for correct files extension.
 *
 * @inputFiles {Array} array of file items
 * @options {Object}{fileExtension} array of the file extensions to be checked for
 * Example: ["jpeg", "jpg", "pdf"]
 */
export default function fileExtension(inputFiles, options = {}) {
    let allowedExtensions = options.fileExtension || [];
    if (!options.caseSensitive) {
        allowedExtensions = allowedExtensions.map(i => i.toLowerCase());
    }
    // In case the file upload is in a flow the format of the "toValidate" argument is and object,
    // instead of an array. In this case it is expected that the array this function needs to validate,
    // is the value of its "files" property.
    let files = inputFiles;
    if (inputFiles.hasOwnProperty("files")) {
        files = inputFiles.files;
    }
    if (!files || !files.length) {
        return true;
    }
    //check all items are files
    if (files.some(item => item.constructor !== File)) {
        WEBUILogs.error("One of the items is not of type File!");
        return false;
    }
    //check if every file has one of the allowed extensions
    return files.every(file => checkFileExtension(file, allowedExtensions, options.caseSensitive));
}

function checkFileExtension(file, allowedExtensions, caseSensitive) {
    let extensionRegex = /\.([^.]*)$/;
    let regexResult = extensionRegex.exec(file.name) || [];
    let fileExtension = regexResult[1];
    if (!fileExtension) {
        return false;
    }
    if (!caseSensitive) {
        fileExtension = fileExtension.toLowerCase();
    }
    return allowedExtensions.includes(fileExtension);
}
